import { DataUsageOutlined } from "@material-ui/icons";
import { create } from "apisauce";
import Cookies from "js-cookie";
import { getNowDateIso, getNextDateIso } from "../utils/utils";


const customerkey = "ck_071866974b2bda6f3c6a46d3ea46f921f7d9f5ec";
const customersecret = "cs_881614a8fbb1bd3a6ea3886aa534f58bc8b86252";

const baseurl = "https://maemiaccesorios.com/wp-json/wc/v3";
let credentials = `consumer_key=${customerkey}&consumer_secret=${customersecret}`;
const ActualMonth = getNowDateIso();
const NextMonth = getNextDateIso();

const api = create({
  baseURL: baseurl,
  headers: { Accept: "application/vnd.github.v3+json" },
});

export const getOrderById = (orderId) =>
  api.get(`/orders/${orderId}?${credentials}`);


export const getCustomerOrders = () =>
  api.get(`/orders?status=enviado&${credentials}`);

export const getAllOrdersWhosales = (numpage = 1) =>
  api.get(
    `/orders?status=sendwholesaler&per_page=100&page=${numpage}&before=${NextMonth}&after=${ActualMonth}&${credentials}`
  );

export const getReportsTotal = () =>
  api.get(`/reports/orders/totals?${credentials}`);

export const reportSalesToday = () => api.get(`/reports/sales?${credentials}`);

export const getCustomerOrdersEnviados = () =>
  api.get(`/orders?status=processing&${credentials}`);

export const getCustomerOrderssendwholesaler = () =>
  api.get(`/orders?status=sendwholesaler&per_page=100&${credentials}`);


const getAllPages = async (path) => {
  const firstPage = await api.get(`${path}&per_page=100&page=1`);
  if (!firstPage.ok) return firstPage;

  const totalPages = Number(firstPage.headers?.["x-wp-totalpages"]) || 1;
  let data = [...firstPage.data];

  for (let page = 2; page <= totalPages; page++) {
    const res = await api.get(`${path}&per_page=100&page=${page}`);
    if (res.ok) data = data.concat(res.data);
  }

  return { ...firstPage, data };
};

export const GetAllCategorys = () =>
  getAllPages(`/products/categories?${credentials}`);

export const AddProductWC = (data) =>api.post(`/products?${credentials}`, {data});

export const GetAllAttributes = () =>
    api.get(`/products/attributes?${credentials}&per_page=100`);

export const GetAllTermsAttributes = (id) =>
  getAllPages(`/products/attributes/${id}/terms?${credentials}`);


export  const AddAttributes = (data) =>
api.put(`/products/${Cookies.get('productid')}/?${credentials}`, data);